import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRef, useState } from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';

const PortableDesign: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('OceanProHomeSolarBattery.PortableDesign');

    const swiperRef = useRef<any>(null);

    const items = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1755568965581-alx4hc-compressed-%3C10%20ms%20auto-switch_1.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1755569076922-hlozs1-compressed-Frame%201000008913.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1755569126519-7rwp96-compressed-%E5%9B%BE%E7%89%87.jpg',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1755569042911-ahmr1s-compressed-Frame%201612707800.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1755569088209-k97ol1-compressed-Frame%201612707802.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1755569138251-6oelsu-compressed-%E5%9B%BE%E7%89%87.jpg',
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1755569058045-251wxz-compressed-Frame%201612707801.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1755569108782-rhl93x-compressed-Frame%201612707803.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1755569154938-2e3rbp-compressed-%E5%9B%BE%E7%89%87.jpg',
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    const onmouseenter = (target: any, index: number) => {
        setActiveIndex(index);
    };

    return (
        <div className={styles.PortableDesign}>
            <EcoSectionCommon title={t('title')} />

            <div className="design-container">
                <div className="design-content">
                    <div className="pc-layout box">
                        {items.map((item, index) => (
                            <div
                                className={`item ${index === activeIndex ? 'active' : ''}`}
                                key={index}
                                onMouseEnter={(e) => onmouseenter(e.currentTarget, index)}
                            >
                                <div className="content">
                                    <div className="title">{item.title}</div>
                                    {activeIndex === index && <div className="desc">{item.desc}</div>}
                                </div>
                                <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} />
                            </div>
                        ))}
                    </div>

                    <div className="pad-layout pad-only">
                        <Swiper
                            className="device-swiper"
                            slidesPerView={'auto'}
                            spaceBetween={12}
                            initialSlide={0}
                            modules={[Pagination]}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            pagination={{
                                clickable: true,
                                el: '.swiper-pagination-custom',
                                type: 'bullets',
                                renderBullet: (index, className) => {
                                    return `<span class="${className}"></span>`;
                                },
                            }}
                        >
                            {items.map((item, index) => (
                                <SwiperSlide key={index} className="list-item">
                                    <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} />
                                    <div className="bottom-content">
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="swiper-pagination-custom"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PortableDesign;
